exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ledger-tab[data-v-d294b6dc]{left:-45px}.ledger-tab[data-v-d294b6dc],.ledger-tab .ledger-tab-item[data-v-d294b6dc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ledger-tab .ledger-tab-item[data-v-d294b6dc]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:40px;height:100px;padding:0 10px;margin-bottom:20px;text-align:center;background-color:#2a4e51;color:#fff;font-size:14px;cursor:pointer}.ledger-tab .active[data-v-d294b6dc]{color:#9aeaff}", ""]);

// exports
